'use client';

import { getTrackOrder } from '@/api/order';
import { useCallback, useState } from 'react';

// 搜索状态类型
interface SearchState {
  loading: boolean;
  error: string | null;
  searchResults: any;
  hasSearched: boolean;
  showTrackOrder: boolean;
}

export const useTrackOrderSearch = () => {
  const [searchState, setSearchState] = useState<SearchState>({
    loading: false,
    error: null,
    searchResults: null,
    hasSearched: false,
    showTrackOrder: false,
  });

  // 搜索订单
  const searchOrder = useCallback(async (searchValue: string) => {
    setSearchState((prev) => ({
      ...prev,
      loading: true,
      error: null,
      hasSearched: false,
    }));

    try {
      // 调用搜索API
      const response = await getTrackOrder({
        search_value: searchValue,
        page: 'track_order',
      });

      if (response.code === 200) {
        setSearchState((prev) => ({
          ...prev,
          loading: false,
          searchResults: response.data,
          hasSearched: true,
          error: null,
          showTrackOrder: true,
        }));
      } else {
        setSearchState((prev) => ({
          ...prev,
          loading: false,
          error: response.msg || 'Search failed',
          hasSearched: true,
          searchResults: null,
          showTrackOrder: false,
        }));
      }
    } catch (error) {
      setSearchState((prev) => ({
        ...prev,
        loading: false,
        error: error instanceof Error ? error.message : 'An unknown error occurred',
        hasSearched: true,
        searchResults: null,
        showTrackOrder: false,
      }));
    }
  }, []);

  // 重置搜索状态
  const resetSearch = useCallback(() => {
    setSearchState({
      loading: false,
      error: null,
      searchResults: null,
      hasSearched: false,
      showTrackOrder: false,
    });
  }, []);

  return {
    searchState,
    searchOrder,
    resetSearch,
  };
};
